import { topicWall } from '@/mocks/home';
import SectionHeading from '@/pages/home/components/SectionHeading';

const sizeClass: Record<string, string> = {
  lg: 'text-base px-5 py-3',
  md: 'text-sm px-4 py-2.5',
  sm: 'text-xs px-3.5 py-2',
};

const tones = [
  'bg-accent-100 text-accent-900 border-accent-200',
  'bg-secondary-100 text-secondary-900 border-secondary-200',
  'bg-primary-100 text-primary-900 border-primary-200',
  'bg-background-100 text-foreground-700 border-background-300',
];

export default function TopicWall() {
  return (
    <section id="topics" className="bg-background-50">
      <div className="mx-auto max-w-6xl px-4 py-16 md:px-6 md:py-24">
        <SectionHeading
          index="04"
          eyebrow="Topic Wall"
          title="话题墙"
          desc="所有正在被补充的话题都挂在这里，字号代表讨论规模，数字是累计出现的线索条数。"
        />

        <div className="flex flex-wrap items-center gap-3 md:gap-4">
          {topicWall.map((topic, index) => (
            <a
              key={topic.id}
              href="#timeline"
              className={`inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full border transition-transform hover:-translate-y-0.5 ${sizeClass[topic.size]} ${tones[index % tones.length]}`}
            >
              {topic.label}
              <span className="font-label text-[11px] opacity-60">{topic.count}</span>
            </a>
          ))}
        </div>

        <p className="mt-10 flex items-center gap-2 text-sm text-foreground-500">
          <i className="ri-lightbulb-line text-base text-accent-600" />
          话题墙按讨论增量实时上浮，冷下来的话题会自动退到后面。
        </p>
      </div>
    </section>
  );
}